// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"421":"175464f1","453":"275a6b21"}[chunkId] + ".chunk.js";
};